import { render, staticRenderFns } from "./BlocksSort.vue?vue&type=template&id=21e6da30&scoped=true"
import script from "./BlocksSort.vue?vue&type=script&lang=js"
export * from "./BlocksSort.vue?vue&type=script&lang=js"
import style0 from "./BlocksSort.vue?vue&type=style&index=0&id=21e6da30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e6da30",
  null
  
)

export default component.exports